import React, { useMemo } from "react";
import { Spinner, Alert } from "reactstrap";
import IntlMessages from "Util/IntlMessages";

export type AsyncStateBoundaryProps = {
  loading: boolean;
  error?: string | null;
  empty?: boolean;
  emptyMessageId?: string;
  children: React.ReactNode;
  minHeight?: number;
};

export default function AsyncStateBoundary({
  loading,
  error,
  empty,
  emptyMessageId = "suite.state.empty",
  children,
  minHeight = 120
}: AsyncStateBoundaryProps) {
  const loadingStyle = useMemo(() => ({ minHeight }), [minHeight]);
  if (loading) {
    return (
      <div
        className="d-flex align-items-center justify-content-center text-muted py-5"
        style={loadingStyle}
      >
        <Spinner color="primary" className="me-2" />
        <span className="small">Loading…</span>
      </div>
    );
  }
  if (error) {
    return (
      <Alert color="danger" className="mb-0">
        {error}
      </Alert>
    );
  }
  if (empty) {
    return (
      <p className="text-muted mb-0 py-4 text-center">
        <IntlMessages id={emptyMessageId} />
      </p>
    );
  }
  return <>{children}</>;
}
